<div class="tw-flex tw-flex-col tw-gap-4 tw-w-full">
  <button pButton pRipple label="Add Reward" (click)="dialogVisible=true"></button>

  @for (reward of rewards; track $index) {
  <p-card>
    <div class="tw-flex tw-flex-row tw-w-full">
      <div class="tw-flex-grow tw-flex tw-flex-col">
        <h2>{{reward.Title}}</h2>
        <h3>Cost: {{reward.Cost}} point(s)</h3>
      </div>
      <div class="tw-flex tw-flex-col tw-gap-2 tw-justify-end">
        <i (click)="detail=reward;dialogVisible=true" class="pi pi-pencil tw-cursor-pointer"></i>
        <p-inputSwitch id="active" [title]="reward.IsActive?'Deactivate':'Activate'" [(ngModel)]="reward.IsActive"
          (ngModelChange)="save(reward)"></p-inputSwitch>
      </div>
    </div>
  </p-card>
  }
</div>

<p-dialog header="Add Reward" [(visible)]="dialogVisible" [modal]="true" appendTo="body" [style]="{'min-width': '50vw'}">
  <brt-reward-save [reward]="detail" (onSave)="load()"></brt-reward-save>
</p-dialog>